import { arrayEncodeAndDecodeOptions, objectEncodeAndDecodeOptions, } from './json-encode';
import { lzEncodeAndDecodeOptions } from './lz-encode';
import { primitiveEncodeAndDecodeOptions } from './util';
export default {
    number: primitiveEncodeAndDecodeOptions({
        encode: (value) => value.toString(),
        decode: (value) => (value ? parseFloat(value) : null),
    }),
    boolean: primitiveEncodeAndDecodeOptions({
        encode: (value) => value + '',
        decode: (value) => value !== null && value !== 'false',
    }),
    string: primitiveEncodeAndDecodeOptions({
        encode: (value) => value ?? '',
        decode: (value) => value,
    }),
    object: objectEncodeAndDecodeOptions,
    array: arrayEncodeAndDecodeOptions,
    lz: lzEncodeAndDecodeOptions,
};
